import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  inject,
} from '@angular/core';
import { SessionStorageService } from '../../services/session-storage.service';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-grid-column-filter',
  templateUrl: './grid-column-filter.component.html',
  styleUrls: ['./grid-column-filter.component.scss'],
  imports: [MatIconModule, MatMenuModule, CommonModule, MatButtonModule],
})
export class GridColumnFilterComponent implements OnInit, OnChanges {
  private ss = inject(SessionStorageService);

  @Input() columns: any[] = [];
  @Input() omitCols: string[] = [];
  @Output() columnsUpdated = new EventEmitter();

  updatedColumns = [];

  ngOnInit(): void {
    this.updateIncomingHeaders(this.columns);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (Object.prototype.hasOwnProperty.call(changes, 'columns')) {
      this.updateIncomingHeaders(changes.columns.currentValue);
    }
  }

  selectionChange(ev, val) {
    ev.stopPropagation();
    ev.preventDefault();

    if (ev.target) {
      ev.target.classList.toggle('selected');
    }

    if (this.updatedColumns.includes(val)) {
      const idx = this.updatedColumns.indexOf(val);
      this.updatedColumns.splice(idx, 1);
    } else {
      this.updatedColumns.push(val);
    }

    this.columnsUpdated.emit(this.updatedColumns);
  }

  updateIncomingHeaders(cols) {
    if (cols) {
      this.updatedColumns = cols
        .map(x => {
          if (!x['Hidden']) {
            return x['DataField'];
          }
        })
        .filter(x => typeof x !== 'undefined');
    }
    this.columns = this.columns.filter(gridItem => {
      return (
        !this.omitCols?.includes(gridItem.DataField) &&
        ((Object.keys(gridItem).includes('right') &&
          this.ss.get('rights').includes(gridItem['right'])) ||
          !Object.keys(gridItem).includes('right'))
      );
    });
  }
}
